import React from 'react';
import ApiPage from '@/components/Pages/ApiPage';

export default function Api() {
  return <ApiPage />;
}
